export const MultiplyBy100AndRound = (amount?: number) => (amount ? Math.round(amount * 100) : 0);
